import { RESET_DAYEND_POPUP, SET_DAYEND_POPUP, SET_DAYEND_STATE } from "../types/dayEndTypes";

export const setDayEndPopup = (value: boolean) => ({
  type: SET_DAYEND_POPUP,
  payload: value,
});

export const resetDayEndPopup = () => ({
  type: RESET_DAYEND_POPUP,
});

export const setDayEndState = (value: any) => ({
  type: SET_DAYEND_STATE,
  payload: value
})